export default __webpack_public_path__ + "static/media/cerebrisans-regular.81bf15fd.woff";